import { useEffect } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { useLocation } from 'react-router-dom';

import { LEARN_HOME_REDIRECT_ORGANIZATION_SLUGS } from '@/views/LearnDashboard/constants';
import { useLearnDashboardContext } from '@/views/LearnDashboard/context';

/**
 * TODO: Eliminar este guard cuando se solucione el bug de home para
 * las organizaciones en LEARN_HOME_REDIRECT_ORGANIZATION_SLUGS.
 * Referencia: https://crehana.atlassian.net/browse/CELC-4195
 * Coordinar con @Jackelyn G (Luch) para desactivar este guard.
 */
export const LearnDashboardRedirectGuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { pathname, search } = useLocation();
  const { organizationSlug, redirectTo } = useLearnDashboardContext();

  const redirectPath = `/org/${organizationSlug}/learn/`;
  const isLearnHome =
    pathname === redirectPath || pathname === redirectPath.replace(/\/$/, '');
  const shouldRedirect =
    isLearnHome &&
    !!organizationSlug &&
    LEARN_HOME_REDIRECT_ORGANIZATION_SLUGS.includes(organizationSlug);
  const redirectUrl = organizationSlug
    ? `/org/${organizationSlug}/home/${search || ''}`
    : '';

  useEffect(() => {
    if (shouldRedirect && redirectUrl) {
      redirectTo(redirectUrl, { replace: true });
    }
  }, [shouldRedirect, redirectUrl, redirectTo]);

  if (shouldRedirect) {
    return null;
  }

  return <>{children}</>;
};
